









































































import { Component, Prop, Vue } from "vue-property-decorator";
import _ from "lodash";
import BudgetRepository from "@/repositories/socle/BudgetRepository";
import EventBus from "front-component/EventBus";
import Http from "front-component/Http";
import moment from "moment";

const components = {
};

@Component({components})
export default class ValidationCampaignForm extends Vue {
    private loading: boolean = false;

    @Prop({type: Number, default: 0}) public globalBudget!: number | null;
    @Prop(Boolean) public visible!: boolean;
    @Prop(Boolean) public isAllBudgets!: boolean;
    @Prop(Object) public filters!: object;
    @Prop() public budgetAvailable: any;
    @Prop() public budgetExpired: any;
    @Prop() public budgetValidated: any;
    @Prop(Number) public countBudgets!: number;
    @Prop({default: false}) public socleLight!: boolean;

    public validateBudgets(): any {
        let updated = this.budgetAvailable.length;
        this.loading = true;

        if (this.isAllBudgets === true) {
            const params = { filters: this.filters};
            Http.get(
                "/massbudgetsvalidation",
                params,
                () => {
                    this.loading = false;
                    EventBus.$emit("mass-budget-status-updated");
                    this.$message({
                        message: _.invoke(this.$options.filters, "trans", "BudgetsValidationSuccess"),
                        type: "success"
                    });
                },
                "errorValidateBudgets"
            );
        } else {
            return Promise.all(this.budgetAvailable.map((budget: any) => {
                const socleBudget = {
                    uuid: budget.uuid,
                    validatedAt: moment().format("YYYY-MM-DD HH:mm:ss"),
                    defaultBudget: true
                };
                return BudgetRepository.save(socleBudget).then(() => {
                    updated--;
                    if (0 === updated) {
                        EventBus.$emit("mass-budget-status-updated");
                        this.loading = false;
                    }
                });
            })).catch(() => {
                this.loading = false;
                return;
            });
        }

    }

    public get globalBudgetLocal(): string {
        return _.invoke(this.$options.filters, "price", this.globalBudget);
    }

    public goBack() {
        this.$emit("update:visible", false);
    }

    public closed() {
        this.$emit("closed");
    }
}

